"use client";

import { usePathname, useSearchParams } from "next/navigation";

export default function PreviewExitLink() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const redirectTo = `${pathname}${search ? `?${search}` : ""}`;

  return (
    <a
      href={`/api/draft-mode/disable?redirect=${encodeURIComponent(redirectTo)}`}
      className="fixed right-4 bottom-4 z-[80] rounded-full bg-foundation-black px-5 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-clarity-white shadow-[0_24px_60px_-24px_rgba(0,0,0,0.45)]"
    >
      Exit Preview
    </a>
  );
}
